import {
  USER_ID,
  ACCESS_TOKEN,
  ACCESS_TOKEN_EXPIRE_TIME,
} from '../constants/localStorageKeys';

// data is the response object from API POST /user/login
export default function setUserAuthDataToLocalStorage(data) {
  localStorage.setItem(USER_ID, data.userId);
  localStorage.setItem(ACCESS_TOKEN, data.id); // data.id is the jwt access token
  localStorage.setItem(
    ACCESS_TOKEN_EXPIRE_TIME,
    new Date(data.created).getTime() + (data.ttl * 1000)
  );
}



// WEBPACK FOOTER //
// ./src/toolbox/setUserAuthDataToLocalStorage.js